<template>
    <section>
        <h2 class="mb-3 text-content-lg font-semibold">Default</h2>
        <p class="mb-3">The entire item is draggable</p>
        <DsSortableList
            v-model="defaultExampleList"
            v-slot="{ item }"
            class="flex flex-col gap-2 rounded-md border border-ds-primary-200 p-2"
            itemKey="id"
            tag="ol"
        >
            <li class="rounded-md bg-ds-primary-300 p-2">{{ item.id }} - {{ item.name }}</li>
        </DsSortableList>
        <p class="mt-4 rounded-md border border-ds-primary-200 p-2 text-center">{{ JSON.stringify(defaultExampleList) }}</p>
    </section>
    <section class="mt-8">
        <h2 class="mb-3 text-content-lg font-semibold">Animated</h2>
        <DsSortableList
            v-model="animatedExampleList"
            v-slot="{ item }"
            class="flex flex-col gap-2 rounded-md border border-ds-primary-200 p-2"
            itemKey="id"
            :options="{ animation: 300, ghostClass: 'opacity-25' }"
            tag="ol"
        >
            <li class="rounded-md bg-ds-primary-300 p-2">{{ item.id }} - {{ item.name }}</li>
        </DsSortableList>
        <p class="mt-4 rounded-md border border-ds-primary-200 p-2 text-center">{{ JSON.stringify(animatedExampleList) }}</p>
    </section>
    <section class="mt-8">
        <h2 class="mb-3 text-content-lg font-semibold">With handle</h2>
        <p class="mb-3">Only the handle is draggable</p>
        <DsSortableList
            v-model="withHandleExampleList"
            v-slot="{ item }"
            class="flex flex-col gap-2 rounded-md border border-ds-primary-200 p-2"
            itemKey="id"
            :options="{ animation: 300, handle: '.handle', ghostClass: 'opacity-25' }"
            tag="ol"
        >
            <li class="flex items-center gap-2 rounded-md bg-ds-primary-300 p-2">
                <DsIcon
                    class="handle cursor-grab"
                    icon="fa-solid fa-grip-dots-vertical"
                    size="sm"
                />
                {{ item.id }} - {{ item.name }}
            </li>
        </DsSortableList>
        <p class="mt-4 rounded-md border border-ds-primary-200 p-2 text-center">{{ JSON.stringify(withHandleExampleList) }}</p>
    </section>
</template>

<script setup lang="ts">
import DsIcon from '@/components/design-system/DsIcon.vue';
import DsSortableList from '@/components/design-system/DsSortableList.vue';
import { ref } from 'vue';

const data = [
    { id: 1, name: 'John Doe' },
    { id: 2, name: 'Jane Doe' },
    { id: 3, name: 'Bob Smith' },
    { id: 4, name: 'Alice Johnson' },
    { id: 5, name: 'Charlie Brown' },
];

const defaultExampleList = ref(Object.assign([], data));
const animatedExampleList = ref(Object.assign([], data));
const withHandleExampleList = ref(Object.assign([], data));
</script>
